import React from 'react'
import PropTypes from 'prop-types'
import ImageBackground from '../ImageBackground'
import Text from '../Text'

// 68x84

const SIZES = {
    M: {
        width: 40,
        height: 49,
    },
    S: {
        width: 36,
        height: 44,
    },
    XS: {
        width: 32,
        height: 40,
    },
}

const COLORS = {
    dark: 'dark',
    green: 'green',
}

const SplitFlapDigit = ({
    value,
    color,
    size,
}) => {
    const { width, height } = SIZES[size]

    return (
        <ImageBackground
            width={width}
            height={height}
            justifyContent="center"
            imageName={`splitFlapDigit${color === COLORS.green ? 'Green' : ''}@2x.png`}
        >
            <Text
                center
                color={color}
                size="XXXL"
            >
                {value}
            </Text>
        </ImageBackground>
    )
}

SplitFlapDigit.colors = Object.keys(COLORS)

SplitFlapDigit.propTypes = {
    value: PropTypes.number,
    color: PropTypes.oneOf(Object.keys(COLORS)),
    size: PropTypes.oneOf(Object.keys(SIZES)),
}

SplitFlapDigit.defaultProps = {
    value: 5,
    color: 'dark',
    size: 'M',
}

export default SplitFlapDigit
